import React, { FC, ReactElement, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Col, Divider, Form, Row, Typography, Card } from "antd";
import { KeyOutlined, MailOutlined, SendOutlined } from "@ant-design/icons";

import {
  selectErrorMessage,
  selectIsAuthLoading,
  selectSuccessMessage,
} from "../../redux-toolkit/auth/auth-selector";
import { setAuthLoadingState } from "../../redux-toolkit/auth/auth-slice";
import { LoadingStatus } from "../../types/types";
import FormInput from "../../components/FormInput/FormInput";
import IconButton from "../../components/IconButton/IconButton";
import { forgotPassword } from "../../redux-toolkit/auth/auth-thunks";
import "./ForgotPassword.css"; // ✅ Add new scoped CSS

const ForgotPassword: FC = (): ReactElement => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const error = useSelector(selectErrorMessage);
  const success = useSelector(selectSuccessMessage);
  const isLoading = useSelector(selectIsAuthLoading);

  useEffect(() => {
    dispatch(setAuthLoadingState(LoadingStatus.LOADED));
  }, []);

  useEffect(() => {
    form.resetFields();
  }, [success]);

  const onClickSend = (value: { email: string }): void => {
    dispatch(forgotPassword(value.email));
  };

  return (
    <div className="forgot-container">
      <Card className="forgot-card" bordered={false}>
        <div className="forgot-header">
          <KeyOutlined className="forgot-icon" />
          <Typography.Title level={4} className="forgot-title">
            Forgot Password?
          </Typography.Title>
        </div>

        <Divider />

        <Typography.Text className="forgot-instructions">
          Enter your email address that you used to create your account.
        </Typography.Text>

        <Form form={form} onFinish={onClickSend} layout="vertical">
          {error && (
            <Alert
              type="error"
              message={error}
              showIcon
              style={{ marginBottom: 12 }}
            />
          )}
          {success && (
            <Alert
              type="success"
              message={success}
              showIcon
              style={{ marginBottom: 12 }}
            />
          )}

          <FormInput
            title="E-mail:"
            icon={<MailOutlined />}
            titleSpan={8}
            wrapperSpan={16}
            name="email"
            placeholder="Enter your email"
            rule={[{ required: true, message: "Please input your E-mail!" }]}
          />

          <div style={{ textAlign: "center", marginTop: 20 }}>
            <IconButton
              disabled={isLoading}
              title="Send"
              icon={<SendOutlined />}
            />
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default ForgotPassword;
